// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { BULK_EDITS_FILTER } from 'components/BulkUpdates/constants'
import { castToFloat } from 'helpers/reduxFormFunctions'

import {
  hasEmptyValue,
  pathContainsSubstring,
} from 'redux/modules/projectSummary/helpers'

// paths is a List of pathSummary objects.
// this will take the values from the BULK_EDITS_FILTER
// and create a reduced list of paths which should be displayed based on this.

const filterPaths = paths => (dispatch, getState) => {
  const {
    bandId,
    filterCheckbox,
    filterInput,
    filterSelect,
  } = getState().form[BULK_EDITS_FILTER].values

  const filterBandId = castToFloat(bandId)

  return paths.filter(p => (
    // we will always have a bandId filtering here. make sure that the given bandId matches
    filterBandId === p.get('bandId') &&

    // if the input doesn't have a value and the checkbox isn't checked,
    // no need to check the filtering logic.
    ((!filterInput && !filterCheckbox) ||

    // if the checkbox is checked, then we want to display
    // all paths that do not have a value assigned for the
    // entity which is specified in the select element.
    // so, like an un-filter
    (filterCheckbox && hasEmptyValue(filterSelect, p)) ||

    // if the checkbox isn't checked, verify that the input value is contained
    // within the path somewhere when determining if we should filter this path out or not.
    (!filterCheckbox && pathContainsSubstring(p, filterSelect, filterInput)))
  ))
}

export default filterPaths
